import { FINISH_EXPOSURE_RECALCULATION, START_EXPOSURE_RECALCULATION, RECHECK_PANELS_EXPO } from '../panelsActions';
import { dispatch, state } from '__common/store';
import { reCheckPanelsExposure } from '__common/components/exposure/exposureCheckInsideOfEditor';
import hash from 'object-hash';
import { canUseExposure } from '__common/components/exposure/exposureHelper';
import { isAscender } from '__common/constants/products';

export const launchRecheckPanelExposure = (
  panelsToRecheck: number[],
  roofId: number,
  cb?: Function,
  force?: boolean,
) => {
  const {
    projectConfiguration: {
      projectEnvConfig: { building_code },
      productId,
    },
    panels: { panels, exposureRecaluclationHash },
  } = state();


  if (!canUseExposure(building_code, productId) || isAscender(productId)) {
    if (cb) {
      cb();
    }
    return;
  }

  const panelsHash = hash(panels);

  if (force) {
    dispatch(START_EXPOSURE_RECALCULATION());
    setTimeout(() => {
      try {
        dispatch(RECHECK_PANELS_EXPO(panelsToRecheck, roofId, productId));
        if (cb) {
          cb();
        }
      } finally {
        if (state().panels.exposureRecalculation) {
          dispatch(FINISH_EXPOSURE_RECALCULATION());
        }
      }
    },         50);
    return;
  }

  if (panelsHash !== exposureRecaluclationHash) {
    dispatch(START_EXPOSURE_RECALCULATION());
    setTimeout(() => {
      try {
        dispatch(RECHECK_PANELS_EXPO(panelsToRecheck, roofId, productId));
        if (cb) {
          cb();
        }
      } finally {
        if (state().panels.exposureRecalculation) {
          dispatch(FINISH_EXPOSURE_RECALCULATION());
        }
      }
    },         1000);
  } else if (cb) {
    cb();
  }
};

export const checkPanelsExposure = (
  panelsOnRoof: panelInState[],
  panelsToRecheck: number[],
  roofId: number,
) => {
  const { panels, forceExposureChanged } = reCheckPanelsExposure(
    panelsOnRoof,
    panelsToRecheck,
    roofId,
  );
  const recheckedPanelIds = new Set(panelsToRecheck);

  return panels.map(panel => {
    if (forceExposureChanged[panel.id] !== undefined) {
      panel.exposedNeighbour = forceExposureChanged[panel.id];
    } else if (recheckedPanelIds.has(panel.id)) {
      panel.exposedNeighbour = false;
    }
    if (panel.manualExposure === 'NE') {
      panel.exposedNeighbour = false;
    }
    return panel;
  });
};
